module.exports = __webpack_public_path__ + "static/media/FranjaApp_Rocket.5912d380.png";